/**
 * Trigger analytics event which described here: https://github.homedepot.com/thd-olt-component-react/thd-analytics
 * @param {String} eventName
 * @param {Object} args.output contains payload data for analytics event
 *
 */
export const triggerAnalytics = (eventName, args = {}) => {
  LIFE_CYCLE_EVENT_BUS?.lifeCycle?.trigger(eventName, args);
};
